import ContentfulAuthor from 'models/data/contentful/ContentfulAuthor'
import ContentfulToApiImage from 'models/data/mappings/ContentfulToApiImage'

class ContentfulToApiAuthor {

    static apiPicture = contentfulAuthor => {
        const contentfulImage = ContentfulAuthor.picture(contentfulAuthor)
        return ContentfulToApiImage.map(contentfulImage)
    }

    static map = (contentfulAuthor) => ({
        id: ContentfulAuthor.id(contentfulAuthor),
        fullName: ContentfulAuthor.fullName(contentfulAuthor),
        shortBiography: ContentfulAuthor.shortBiography(contentfulAuthor),
        picture: ContentfulToApiAuthor.apiPicture(contentfulAuthor),
        twitter: ContentfulAuthor.twitter(contentfulAuthor),
        instagram: ContentfulAuthor.instagram(contentfulAuthor), 
        slug: ContentfulAuthor.slug(contentfulAuthor)
    })
}

export default ContentfulToApiAuthor;
